export const generateStars = (count, input, maxSizeStar) => {
    const stars = [];
    for (let i = 0; i < count; i++) {
        const maxSize = maxSizeStar || 20;
        const additional = input ? 0 : 5;
        const size = input ? Math.random() * 2 + 0.5 : Math.random() * (maxSize - 5) + additional;
        const left = Math.random() * 100;
        const top = Math.random() * 100;
        const starType = Math.floor(Math.random() * 4) + 1;
        const animationDuration = input ? 0.1 : Math.random() * 20 + 20;
        const animationDelay = input ? 0.1 : Math.random() * 5;
        stars.push({ size, left, top, starType, animationDuration, animationDelay });
    }
    return stars;
};
export function rng(seed = 123456) {
    let x = seed >>> 0;
    return () => {
        x ^= x << 13;
        x ^= x >>> 17;
        x ^= x << 5;
        return ((x >>> 0) % 10000) / 10000;
    };
}
export function genTinyStars(count = 15, edge = 7, minSize = 4, maxSize = 17) {
    const r = rng(1337);
    const stars = [];
    const sep = 4;
    while (stars.length < count) {
        const x = edge + r() * (100 - edge * 2);
        const y = edge + r() * (100 - edge * 2);
        const size = Math.floor(minSize + r() * (maxSize - minSize + 1));
        if (stars.every((s) => Math.hypot(s.x - x, s.y - y) >= sep)) {
            stars.push({ x, y, size });
        }
    }
    return stars;
}
